export default __webpack_public_path__ + "static/media/canadaRegistrationBackground.dce458d4.jpg";